{
  "titles": {
    "error": "Error",
    "success": "Success",
    "warning": "Warning",
    "notice": "Notice"
  },
  "copied": "Copied to clipboard",
  "saved": "Saved successfully.",
  "deleted": "Deleted successfully.",
  "error_validation": "Please check the highlighted fields and try again.",
  "form_failed": "We couldn't save your {entity}. Please try again."
}
